import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function initFormTemplates(requestor) {
  return createReduxPromiseAction(
    ActionTypes.FORM_TEMPLATES_FETCH,
    (organisationId, projectId) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}/form_template`,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
